import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=0649e3ab&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"
import style0 from "./Fields.vue?vue&type=style&index=0&id=0649e3ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649e3ab",
  null
  
)

export default component.exports